/* eslint-disable no-unused-vars */
import $ from 'jquery';

$(document).ready(() => {
  const $InputDate = $('.js-calendar');

  if (!$InputDate) {
    return;
  }

  require.ensure(['pikaday'], (require) => {
    const Pikaday = require('pikaday');

    $InputDate.each((index, item) => {
      const $item = $(item);

      $item.attr('type', 'text');
      const inputDate = new Pikaday({
        field: item,
        firstDay: 1,
        format: 'DD/MM/YYYY',
        yearRange: [1930, 2017],
        theme: 'netc-calendar',
      });
    });
  });
});
